import { QueryCache, QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { logError } from '@/utils/errorReporter';
import type { Extras } from '@sentry/core';
import { defaultQueryRetry } from './query-retry';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      let extras: Extras = {};
      if (isAxiosError(error)) {
        const axiosResponse = error?.response;
        const url = axiosResponse?.config?.url || error?.config?.url;
        const status = axiosResponse?.status;
        const data = axiosResponse?.data;
        extras = {
          url: url ?? 'Unknown URL',
          status: status ?? 'Unknown status',
          errorBody: data ?? error?.toString() ?? 'No error body',
        };
      }

      logError('Query error', error, 'query-error', {
        message: query.meta?.errorMessage ?? 'Unknown error',
        key: `query-error: ${query.queryKey.join(', ')}`,
        queryKey: query.queryKey,
        queryMeta: query.meta,
        ...extras,
      });
    },
  }),
  defaultOptions: {
    queries: {
      ...defaultQueryRetry,
      refetchOnMount: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    },
  },
});
